module.exports = __webpack_public_path__ + "img/canvasMenu6.942ac5f6.svg";